import * as React from "react";
import { AmountFieldSchema, IInputFieldProps } from "@generation/core";
import { InputAmountField, InputFieldProps } from "@shared/common";
import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";
import { withRegisterFieldHoc } from "../Hoc/withRegisterFieldHoc";
import { withRenderFieldHoc } from "../Hoc/withRenderFieldHoc";
import { useFormPropsContext } from "../Context/FormPropsContextProvider";
import { withValueSetHoc } from "../Hoc/withValueSetHoc";
import { onChangeHoc } from "../Hoc/onChangeHoc";

const RegisteredAmountField = withRegisterFieldHoc(
  withRenderFieldHoc((props: IInputFieldProps<AmountFieldSchema> & InputFieldProps) => {
    const formProps = useFormPropsContext();
    return (
      <InputAmountField
        {...props}
        id={props.name}
        icon={props.field.icon}
        placeholder={props.field.placeholder}
        showMaxLengthMessage={formProps?.fieldDefaults?.text?.maxLengthMessage}
        decimalScale={props.field.decimalScale}
      />
    );
  })
);

export const AmountField = React.memo(
  onChangeHoc(
    withValueSetHoc(
      withHideOnFieldHoc((props: IInputFieldProps<AmountFieldSchema>) => (
        <RegisteredAmountField {...props} displayStyle="block" />
      ))
    )
  )
);
